import React from "react";
import "./AsSeenOn.css";

// Import images
import abcLogo from "../../images/SeenOn/ABC_News.png";
import cbsLogo from "../../images/SeenOn/CBS.png";
import foxLogo from "../../images/SeenOn/Fox.svg";
import nbcLogo from "../../images/SeenOn/NBC.svg";
import cwLogo from "../../images/SeenOn/the-cw.png";

const AsSeenOn = () => {
  const logos = [
    { src: abcLogo, alt: "ABC News" },
    { src: cbsLogo, alt: "CBS" },
    { src: foxLogo, alt: "Fox" },
    { src: nbcLogo, alt: "NBC" },
    { src: cwLogo, alt: "The CW" },
  ];

  return (
    <div className="as-seen-on-container">
      <h3 className="as-seen-on-title">As Seen On</h3>
      <div className="as-seen-on-logos">
        {logos.map((logo, index) => (
          <div key={index} className="logo-wrapper">
            <img src={logo.src} alt={logo.alt} className="media-logo" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default AsSeenOn;
